/* Ported from the standalone Alpha Male page. The only change from the original is
   this block: media URLs and store config now come from the section's data attributes,
   because theme assets and Shopify Files live at CDN paths the page cannot hardcode.
   Every lookup falls back to the original relative path, so this file still runs
   outside Shopify unchanged. */
var AM_CFG = (function () {
  var el = document.getElementById('am-landing-data');
  var d = (el && el.dataset) ? el.dataset : {};
  return function (key, fallback) {
    var v = d[key];
    return (v === undefined || v === null || v === '') ? fallback : v;
  };
})();
(function(){
'use strict';

/* ==========================================================================
   Store URL. See README.md for how these are wired.
   Put your store URL between the quotes. Every "Get a bottle" button and all
   three price tiers will point at it immediately. Leave it empty and the
   buttons say the store is not open yet, rather than silently doing nothing.
   You can also give each pack its own checkout link in BUY_LINKS below.
   ========================================================================== */
var SMOKE_SRC = AM_CFG('smokeLoop', 'assets/smoke-loop.mp4');   /* one literal: the build inlines it once */

var BUY_URL   = AM_CFG('buyUrl', '');
var BUY_LINKS = { '1': AM_CFG('buy1', ''), '2': AM_CFG('buy2', ''), '3': AM_CFG('buy3', '') };   /* optional per-pack links */
var SUPPORT_EMAIL = AM_CFG('supportEmail', 'alpha-male@prodigy-media.com');        /* the address already shown in the footer */

(function wireBuying(){
  var pick = function(n){ return (BUY_LINKS[n] || BUY_URL || ''); };
  var live = !!(BUY_URL || BUY_LINKS['1'] || BUY_LINKS['2'] || BUY_LINKS['3']);

  /* Both buy boxes behave identically: the radio is the source of truth, the card only
     reflects it, and the CTA reads it at click time rather than caching a URL. */
  document.querySelectorAll('.buy').forEach(function(box){
    var ins  = [].slice.call(box.querySelectorAll('.opt__in'));
    var cta  = box.querySelector('.cta');

    /* On the Shopify build the CTA is a real submit button inside {% form 'product' %}
       and the radio value is a variant id, so none of the outbound-link handling below
       applies to it. It actively BROKE it: pick() found no URL for a variant id, the
       button got aria-disabled, and the click handler then preventDefault()ed the form
       submit -- Add to cart looked wired and silently did nothing. Tam's original CTA was
       an <a> pointing at Amazon per pack, which is what this code is for, so it stays for
       any build still using that path and steps aside when Shopify owns the button. */
    var shopifyCart = !!(cta && cta.form && cta.type === 'submit');

    function sync(){
      ins.forEach(function(i){
        var card = i.parentNode;
        card.classList.toggle('is-sel', i.checked);
      });
      if (!cta || shopifyCart) { return; }
      var chosen = box.querySelector('.opt__in:checked');
      var url = chosen ? pick(chosen.value) : '';
      if (url) { cta.href = url; cta.removeAttribute('aria-disabled'); }
      else { cta.href = '#'; cta.setAttribute('aria-disabled', 'true'); }
    }

    ins.forEach(function(i){ i.addEventListener('change', sync); });
    if (cta && !shopifyCart) cta.addEventListener('click', function(e){
      if (cta.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });
    sync();
  });

  /* anchors marked data-jump stay in-page: they scroll to the offer rather than leaving */
  document.querySelectorAll('a[href="#get"], #buy').forEach(function(a){
    if (BUY_URL && !a.hasAttribute('data-jump')) a.href = BUY_URL;
  });

  document.querySelectorAll('.buy__mail').forEach(function(a){
    if (SUPPORT_EMAIL) a.href = 'mailto:' + SUPPORT_EMAIL;
  });
})();


/* ------------------------------------------------ reviews that open
   Measured after fonts settle: a control is only added to a card that is really hiding
   something, so a short review does not get a "read more" that reveals nothing. */
(function expandableReviews(){
  function build(){
    document.querySelectorAll('.rev').forEach(function(fig, i){
      if (fig.dataset.exp) return;
      var q = fig.querySelector('blockquote');
      if (!q || q.scrollHeight - q.clientHeight < 8) return;
      fig.dataset.exp = '1';
      fig.classList.add('rev--clip');
      if (!q.id) q.id = 'revq' + i;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rev__more';
      b.textContent = 'Read more';
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-controls', q.id);
      q.parentNode.insertBefore(b, q.nextSibling);
      b.addEventListener('click', function(){
        var open = !fig.classList.contains('open');
        if (open) fig.style.setProperty('--full', q.scrollHeight + 'px');
        fig.classList.toggle('open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? 'Show less' : 'Read more';
      });
    });
  }
  /* One collapsed height for the row, taken from the tallest card once the controls are
     in place. Set in CSS it would have to be a guess; measured it is exact, and a card
     that opens still grows past it on its own. */
  function level(){
    var row = document.getElementById('revs');
    if (!row) return;
    row.style.removeProperty('--rev-h');
    var tallest = 0;
    row.querySelectorAll('.rev').forEach(function(f){
      if (f.classList.contains('open')) return;
      tallest = Math.max(tallest, f.getBoundingClientRect().height);
    });
    if (tallest) row.style.setProperty('--rev-h', Math.ceil(tallest) + 'px');
  }
  function boot(){ build(); level(); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(boot);
  else window.addEventListener('load', boot);
  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(function(){
      document.querySelectorAll('.rev.open').forEach(function(f){
        var q = f.querySelector('blockquote');
        if (q) f.style.setProperty('--full', q.scrollHeight + 'px');
      });
      level();
    }, 140);
  });
})();





/* ------------------------------------------------ guarantee scroll progress
   One value on the section drives everything: the camera transform and every line of the
   copy are clamp() expressions on --sp. Same publisher the scent film uses, minus the video. */
/* The same file is already playing on the fixed environment layer; running both at once
   would show the identical footage twice at two scales and read as a double exposure. The
   ambient layer ducks while this section is on screen. Its source is read off that element
   rather than written as a path, so the build does not inline a second copy. */
(function guaranteeLoop(){
  var sec = document.getElementById('guarantee'), v = document.getElementById('guarLoop'),
      src = document.getElementById('envVideo') || {};
  if (!sec || !v) return;
  var started = false;
  function begin(){
    if (started) return;
    /* prefer the ambient element's resolved source (already warm in cache on desktop), but
       fall back to the shared literal — on a phone the ambient layer is never loaded */
    var url = src.currentSrc || src.getAttribute('src') || SMOKE_SRC;
    if (!url) return;
    started = true;
    v.src = url;
    v.addEventListener('playing', function(){ v.classList.add('on'); }, {once:true});
    v.load();
  }
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      document.body.classList.toggle('guar-lock', e.isIntersecting);
      if (e.isIntersecting){ begin(); var q = v.play(); if (q && q.catch) q.catch(function(){}); }
      else if (started) v.pause();
    });
  }, {rootMargin:'300px 0px'}).observe(sec);
  document.addEventListener('visibilitychange', function(){
    if (!started) return;
    if (document.hidden) v.pause();
    else { var q = v.play(); if (q && q.catch) q.catch(function(){}); }
  });
})();

(function guaranteeProgress(){
  var sec = document.getElementById('guarantee');
  if (!sec) return;
  var raf = 0;
  function step(){
    raf = 0;
    var r = sec.getBoundingClientRect();
    var span = Math.max(1, sec.offsetHeight - window.innerHeight);
    var p = -r.top / span;
    sec.style.setProperty('--sp', (p < 0 ? 0 : p > 1 ? 1 : p).toFixed(4));
  }
  function kick(){ if (!raf) raf = requestAnimationFrame(step); }
  window.addEventListener('scroll', kick, {passive:true});
  window.addEventListener('resize', kick);
  step();
})();

/* ------------------------------------------------------ small helpers */
var clamp=function(v,lo,hi){return Math.min(hi,Math.max(lo,v));};
var smoothstep=function(p,e0,e1){var t=clamp((p-e0)/(e1-e0),0,1);return t*t*(3-2*t);};
function rng(seed){var s=seed>>>0;return function(){s=(s*1664525+1013904223)>>>0;return s/4294967296;};}

var stage=document.getElementById('stage');
var video=document.getElementById('hero');
var poster=document.getElementById('poster');
var ring=document.getElementById('ring');
var heroSec=document.getElementById('hero-sec');
var nav=document.getElementById('nav');

var VIDEO_URL=AM_CFG('heroScrub', 'assets/hero-scrub.mp4');
var VIDEO_BYTES=parseInt(AM_CFG('heroScrubBytes', '2695156'), 10);

/* ------------------------------------------------- split band headlines */
var bandEls=[].slice.call(document.querySelectorAll('.band'));
var bands=bandEls.map(function(el,i){
  return {el:el,a:parseFloat(el.dataset.a),b:parseFloat(el.dataset.b),
          ramp:el.dataset.ramp?parseFloat(el.dataset.ramp):0,
          op:-1,k:-1};
});

(function splitAll(){
  var rand=rng(20260816);
  document.querySelectorAll('[data-split="word"]').forEach(function(el){
    var spread=parseFloat(el.dataset.spread||'0.3');
    var html=el.innerHTML;
    var text=el.textContent;
    var sr=document.createElement('span');sr.className='sr';sr.textContent=text;
    var vis=document.createElement('span');vis.setAttribute('aria-hidden','true');
    vis.innerHTML=html;
    // wrap each top-level text word
    var words=[];
    (function walk(node){
      [].slice.call(node.childNodes).forEach(function(n){
        if(n.nodeType===3){
          var parts=n.textContent.split(/(\s+)/).filter(function(s){return s.length;});
          var frag=document.createDocumentFragment();
          parts.forEach(function(p){
            if(/^\s+$/.test(p)){frag.appendChild(document.createTextNode(p));return;}
            var w=document.createElement('span');w.className='w';w.textContent=p;
            words.push(w);frag.appendChild(w);
          });
          node.replaceChild(frag,n);
        }else if(n.nodeType===1&&!n.classList.contains('w')){walk(n);}
      });
    })(vis);
    words.forEach(function(w,i){
      var th=(words.length>1?(i/(words.length-1)):0)*spread+rand()*0.05;
      w.style.setProperty('--th',th.toFixed(3));
    });
    el.innerHTML='';el.appendChild(sr);el.appendChild(vis);
  });
})();

/* ------------------------------------------------------- the drive loop */
var target=0,shown=0,rafId=null,lastTick=0,heroOnScreen=true,scrubOn=false;
var loadK=0,loadStart=0;

function heroProgress(){
  var r=heroSec.getBoundingClientRect();
  var range=heroSec.offsetHeight-window.innerHeight;
  if(range<=0)return 0;
  return clamp(-r.top/range,0,1);
}

/* seek gating, deadlock safe */
var seekBusy=false,pendingTime=null;
function requestSeek(t){
  if(!video.duration)return;
  if(seekBusy){pendingTime=t;return;}
  seekBusy=true;
  try{video.currentTime=t;}catch(e){seekBusy=false;}
}
video.addEventListener('seeked',function(){
  seekBusy=false;
  if(pendingTime!==null){var t=pendingTime;pendingTime=null;requestSeek(t);}
});
video.addEventListener('error',function(){seekBusy=false;pendingTime=null;failVideo();});

function tick(now){
  var dt=Math.min(100,now-(lastTick||now));lastTick=now;
  var k=0.16;
  shown+=(target-shown)*(1-Math.pow(1-k,dt/16.667));
  var done=Math.abs(target-shown)<0.0005;
  if(done){shown=target;}
  if(loadStart&&loadK<1){
    loadK=clamp((now-loadStart)/900,0,1);
  }
  if(video.duration)requestSeek(shown*video.duration);
  updateCaptions(shown);
  if(done&&loadK>=1){rafId=null;lastTick=0;}
  else{rafId=requestAnimationFrame(tick);}
}
function onScroll(){
  target=heroProgress();
  if(rafId===null&&heroOnScreen&&scrubOn)rafId=requestAnimationFrame(tick);
}

/* -------------------------------------------- captions, delta gated */
function updateCaptions(p){
  for(var i=0;i<bands.length;i++){
    var b=bands[i];
    var f=Math.min(0.02,(b.b-b.a)/3);
    var inRamp=(i===0)?0:f;
    var outRamp=(i===bands.length-1)?0:f;
    var op=smoothstep(p,b.a,b.a+inRamp)*(1-smoothstep(p,b.b-outRamp,b.b));
    if(i===0)op=(p<=b.b-outRamp)?1:op;
    var ramp=b.ramp||Math.min(0.025,(b.b-b.a)*0.35);
    var kk=clamp((p-b.a)/ramp,0,1);
    if(i===0)kk=Math.max(kk,loadK);
    if(Math.abs(op-b.op)>0.004){b.op=op;b.el.style.opacity=op.toFixed(3);}
    if(Math.abs(kk-b.k)>0.008){
      b.k=kk;
      b.el.style.setProperty('--k',kk.toFixed(3));
      if(b.el.classList.contains('band--split')){
        /* logo first, then headline, then sub + the three beats, then the button */
        b.el.style.setProperty('--kl',clamp(kk*2.0,0,1).toFixed(3));
        b.el.style.setProperty('--kh',clamp((kk-0.30)*2.6,0,1).toFixed(3));
        b.el.style.setProperty('--ks',clamp((kk-0.55)*2.6,0,1).toFixed(3));
        b.el.style.setProperty('--kb',clamp((kk-0.72)*3.4,0,1).toFixed(3));
      }
    }
  }
}

/* ------------------------------------------------ blob load with ring */
var started=false;
function startBlobFetch(){
  if(started)return;started=true;
  loadHeroBlob().catch(failVideo);
}
function initHeroOnce(){
  if(initHeroOnce.done)return;initHeroOnce.done=true;
  poster.style.backgroundImage="url(AM_CFG('heroPoster', 'assets/hero-poster.jpg'))";
  var img=new Image();
  img.onload=function(){poster.classList.add('in');startBlobFetch();};
  img.onerror=startBlobFetch;
  img.src=AM_CFG('heroPoster', 'assets/hero-poster.jpg');
  setTimeout(startBlobFetch,4000);
  loadStart=performance.now();
  if(rafId===null)rafId=requestAnimationFrame(tick);
}
function loadHeroBlob(){
  /* A data: URI is already in the document — there is nothing to stream, and a strict
     connect-src (an artifact/CSP host) refuses to fetch it at all, which would drop the
     whole scrub to the static hero. Hand it straight to the element instead. */
  if(VIDEO_URL.slice(0,5)==='data:'){
    return new Promise(function(resolve,reject){
      video.addEventListener('canplay',function(){
        ring.style.setProperty('--ld',0);
        requestSeek(heroProgress()*video.duration);
        stage.classList.add('video-ready');
        resolve();
      },{once:true});
      video.addEventListener('error',function(){reject(new Error('data uri decode failed'));},{once:true});
      video.src=VIDEO_URL;
      video.load();
    });
  }
  var ctrl=new AbortController();
  var watchdog=setTimeout(function(){ctrl.abort();},20000);
  var opts={signal:ctrl.signal};
  try{opts.priority='low';}catch(e){}
  return fetch(VIDEO_URL,opts).then(function(res){
    if(!res.ok||!res.body)throw new Error('bad response');
    var total=Number(res.headers.get('Content-Length'))||VIDEO_BYTES;
    var reader=res.body.getReader();
    var chunks=[],got=0,lastRing=0;
    function pump(){
      return reader.read().then(function(r){
        if(r.done)return;
        clearTimeout(watchdog);
        watchdog=setTimeout(function(){ctrl.abort();},20000);
        chunks.push(r.value);got+=r.value.length;
        var frac=Math.min(1,got/total),now=performance.now();
        if(now-lastRing>100||frac===1){
          lastRing=now;
          ring.style.setProperty('--ld',Math.round(126*(1-frac)));
        }
        return pump();
      });
    }
    return pump().then(function(){
      clearTimeout(watchdog);
      ring.style.setProperty('--ld',0);
      video.src=URL.createObjectURL(new Blob(chunks,{type:'video/mp4'}));
      video.load();
      video.addEventListener('canplay',function(){
        requestSeek(heroProgress()*video.duration);
        stage.classList.add('video-ready');
      },{once:true});
    });
  });
}
function failVideo(){
  if(failVideo.done)return;failVideo.done=true;
  if(ring&&ring.parentNode){
    var c=document.createElement('div');
    c.className='chev';
    c.innerHTML='<svg viewBox="0 0 22 34" fill="none" aria-hidden="true"><path d="M4 12l7 7 7-7" stroke="currentColor" stroke-width="2"/></svg>';
    ring.parentNode.replaceChild(c,ring);
  }
  stage.classList.add('video-failed');
}

/* ------------------------------------------- the five static-hero gates */
var GATES=[
  '(max-width: 720px)',
  '(orientation: portrait) and (max-width: 1024px)',
  '(orientation: portrait) and (pointer: coarse)',
  '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)'
  /* reduced-motion deliberately NOT a gate: a scroll-driven scrub is user-driven,
     not involuntary motion. Ambient loops and embers keep their own checks. */
];
var MQLS=GATES.map(function(q){return matchMedia(q);});

function enableScrub(){
  if(scrubOn)return;scrubOn=true;
  initHeroOnce();
  window.addEventListener('scroll',onScroll,{passive:true});
  bands.forEach(function(b){b.op=-1;b.k=-1;});
  unpinFinalStates();
  updateCaptions(heroProgress());
  onScroll();
}
function disableScrub(){
  if(!scrubOn)return;scrubOn=false;
  window.removeEventListener('scroll',onScroll);
  if(rafId!==null){cancelAnimationFrame(rafId);rafId=null;}
}
function applyHeroMode(){
  var hit=MQLS.some(function(m){return m.matches;});
  if(hit)disableScrub();else enableScrub();
}
MQLS.forEach(function(m){
  if(m.addEventListener)m.addEventListener('change',applyHeroMode);
  else if(m.addListener)m.addListener(applyHeroMode);
});

if('IntersectionObserver' in window){
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      heroOnScreen=e.isIntersecting;
      if(heroOnScreen&&scrubOn&&rafId===null)rafId=requestAnimationFrame(tick);
    });
  },{rootMargin:'120px'}).observe(heroSec);
}

/* ----------------------------------------------------- nav solid state */
var navSolid=false;
window.addEventListener('scroll',function(){
  var s=window.scrollY>60;
  if(s!==navSolid){navSolid=s;nav.classList.toggle('solid',s);}
},{passive:true});

/* ------------------------------------------- product track: pin + rig */
(function(){
  var track=document.getElementById('product'), rig=document.getElementById('rig'),
      bed=document.getElementById('smokeBed');
  if(!track||!rig) return;
  var reduce=window.matchMedia('(prefers-reduced-motion:reduce)');
  var narrow=window.matchMedia('(max-width:880px)');
  var tRaf=null, inView=false, mx=0, my=0, tmx=0, tmy=0, scale=1;

  function publish(){
    tRaf=null;
    var r=track.getBoundingClientRect();
    /* progress through the part of the track that actually scrolls past the pin */
    var span=Math.max(1,r.height-window.innerHeight);
    var t=Math.min(1,Math.max(0,-r.top/span));
    track.style.setProperty('--t',t.toFixed(4));
    /* ease the pointer rather than tracking it raw — raw pointer on a big element
       reads twitchy, and the lag is what makes it feel like weight */
    mx+=(tmx-mx)*0.12; my+=(tmy-my)*0.12;
    rig.style.setProperty('--mx',mx.toFixed(4));
    rig.style.setProperty('--my',my.toFixed(4));
    rig.style.setProperty('--rs',(0.94+0.06*Math.min(1,t*3)).toFixed(4));
    if(inView&&(Math.abs(tmx-mx)>0.001||Math.abs(tmy-my)>0.001)) kick();
  }
  function kick(){ if(tRaf===null) tRaf=requestAnimationFrame(publish); }

  window.addEventListener('scroll',kick,{passive:true});
  window.addEventListener('resize',kick);

  if(!narrow.matches&&!reduce.matches){
    rig.addEventListener('pointermove',function(e){
      var b=rig.getBoundingClientRect();
      tmx=((e.clientX-b.left)/b.width -0.5)*2;
      tmy=((e.clientY-b.top )/b.height-0.5)*2;
      rig.classList.add('is-live'); kick();
    });
    rig.addEventListener('pointerleave',function(){
      tmx=0; tmy=0; rig.classList.remove('is-live'); kick();
    });
  }

  /* ---- the scent film is SCRUBBED, not played: scroll drives currentTime ----
     Same approach as the hero. The video is fetched as a Blob first, because seeking a
     streaming <video> stalls on ranges the browser has not buffered, which shows up as a
     scrub that sticks. Seeks are gated so they can never overlap, and the displayed time
     is eased toward the target so a fast flick glides instead of stepping. */
  (function(){
    var sec=document.getElementById('scent'), v=document.getElementById('scentScrub');
    if(!sec||!v) return;
    var SRC=AM_CFG('scentScrub', 'assets/scent-scrub.mp4');
    var loaded=false, seeking=false, want=0, shown=0, raf=null, live=false;

    function progress(){
      var r=sec.getBoundingClientRect();
      var span=Math.max(1, sec.offsetHeight - window.innerHeight);
      return Math.min(1, Math.max(0, -r.top / span));
    }
    function step(){
      raf=null;
      if(!loaded || !v.duration) return;
      var pr=progress();
      sec.style.setProperty('--sp',pr.toFixed(4));
      want=pr*v.duration;
      shown += (want-shown)*0.18;
      if(Math.abs(want-shown)<0.008) shown=want;
      if(!seeking && Math.abs(v.currentTime-shown)>0.012){
        seeking=true;
        try{ v.currentTime=shown; }catch(e){ seeking=false; }
      }
      if(live && Math.abs(want-shown)>0.004) kick();
    }
    function kick(){ if(raf===null) raf=requestAnimationFrame(step); }
    v.addEventListener('seeked',function(){ seeking=false; kick(); });

    function load(){
      if(loaded) return; loaded=true;
      /* A data: URI is already in the document and a strict connect-src refuses to fetch
         it, which would leave the scrub dead. Hand it straight to the element. */
      if(SRC.slice(0,5)==='data:'){
        v.src=SRC;
        v.addEventListener('loadeddata',function(){ shown=progress()*(v.duration||1); kick(); },{once:true});
        v.load(); return;
      }
      fetch(SRC).then(function(r){ return r.blob(); }).then(function(b){
        v.src=URL.createObjectURL(b);
        v.addEventListener('loadeddata',function(){ shown=progress()*(v.duration||1); kick(); },{once:true});
        v.load();
      }).catch(function(){ v.src=SRC; v.load(); });
    }

    window.addEventListener('scroll',kick,{passive:true});
    window.addEventListener('resize',kick);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ live=e.isIntersecting; if(live){ load(); kick(); } });
      },{rootMargin:'400px 0px'}).observe(sec);
    } else { load(); }
  })();

  /* ---- the mechanism section publishes its own scroll progress ---- */
  (function(){
    var how=document.getElementById('how'); if(!how) return;
    var raf=null;
    function pub(){
      raf=null;
      var r=how.getBoundingClientRect();
      var film=how.querySelector('.loud__film');
      var fh=film?film.getBoundingClientRect().height:0;
      /* Progress through the PINNED stretch: 0 the moment the frame locks, 1 when it
         releases. Measuring against the viewport instead would run the whole reveal off
         before the frame had even settled. */
      var stick=(window.innerHeight-fh)/2;
      var span=Math.max(1,how.offsetHeight-fh);
      var p=(stick-r.top)/span;
      how.style.setProperty('--p',Math.min(1,Math.max(0,p)).toFixed(4));
    }
    function kick(){ if(raf===null) raf=requestAnimationFrame(pub); }
    window.addEventListener('scroll',kick,{passive:true});
    window.addEventListener('resize',kick);
    kick();

    /* this section's own bed, on the same in-view-only rule as the product module's */
    var bed2=document.getElementById('coupleLoop');
    if(bed2&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){
            if(bed2.preload!=='auto'){bed2.preload='auto';bed2.load();}
            if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
              var q=bed2.play(); if(q&&q.catch)q.catch(function(){});
            }
          } else if(!bed2.paused){ bed2.pause(); }
        });
      },{rootMargin:'200px 0px'}).observe(how);
    } else if(bed2){ bed2.preload='auto'; bed2.load(); }
  })();

  /* ---- the review row pages rather than free-scrolls ---- */
  (function(){
    var row=document.getElementById('revs'); if(!row) return;
    var btns=[].slice.call(document.querySelectorAll('.revs__btn'));
    function page(){ var c=row.querySelector('.rev');
      return c ? c.getBoundingClientRect().width + 18 : row.clientWidth * .8; }
    function sync(){
      var max=row.scrollWidth-row.clientWidth-2;
      btns.forEach(function(b){
        var d=+b.dataset.rev;
        b.disabled = (d<0 && row.scrollLeft<=2) || (d>0 && row.scrollLeft>=max);
      });
    }
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var n=Math.max(1,Math.floor(row.clientWidth/page()));
        row.scrollBy({left:+b.dataset.rev*page()*n,behavior:'smooth'});
      });
    });
    row.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  })();

  /* ---- inspection points ---- */
  (function(){
    var host=document.getElementById('spots'); if(!host) return;
    var pin=track.querySelector('.pin'), stack=rig.querySelector('.rig__stack');
    var pairs=[].map.call(host.querySelectorAll('.spot'),function(btn){
      return {btn:btn, note:document.getElementById(btn.getAttribute('aria-controls'))};
    });
    function place(p){
      var pb=pin.getBoundingClientRect(), sb=stack.getBoundingClientRect(),
          bb=p.btn.getBoundingClientRect(), nb=p.note.getBoundingClientRect();
      var GAP=16;
      /* put the card on whichever side of the dot has room inside the pinned frame,
         then clamp — an inspection card that runs off the edge is worse than none */
      var right=pb.right-(bb.right+GAP), left=bb.left-GAP-pb.left;
      var x = (right>=nb.width || right>=left) ? (bb.right+GAP-sb.left)
                                               : (bb.left-GAP-nb.width-sb.left);
      x=Math.max(pb.left+12-sb.left, Math.min(x, pb.right-12-nb.width-sb.left));
      var y=bb.top+bb.height/2-nb.height/2-sb.top;
      y=Math.max(pb.top+12-sb.top, Math.min(y, pb.bottom-12-nb.height-sb.top));
      p.note.style.setProperty('--nx',Math.round(x)+'px');
      p.note.style.setProperty('--ny',Math.round(y)+'px');
    }
    function close(p){ p.note.classList.remove('is-open'); p.btn.setAttribute('aria-expanded','false'); }
    function open(p){
      pairs.forEach(function(q){ if(q!==p) close(q); });
      p.note.classList.add('is-open'); p.btn.setAttribute('aria-expanded','true'); place(p);
    }
    pairs.forEach(function(p){
      p.btn.addEventListener('click',function(e){
        e.stopPropagation();
        p.btn.getAttribute('aria-expanded')==='true' ? close(p) : open(p);
      });
      /* hover and keyboard focus both open it; touch is covered by click */
      p.btn.addEventListener('pointerenter',function(e){ if(e.pointerType!=='touch') open(p); });
      p.btn.addEventListener('focus',function(){ open(p); });
      p.btn.addEventListener('blur',function(){ close(p); });
      p.btn.addEventListener('pointerleave',function(e){ if(e.pointerType!=='touch'&&document.activeElement!==p.btn) close(p); });
    });
    document.addEventListener('click',function(){ pairs.forEach(close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') pairs.forEach(close); });
    window.addEventListener('resize',function(){ pairs.forEach(function(p){ if(p.note.classList.contains('is-open')) place(p); }); });
    window.addEventListener('scroll',function(){ pairs.forEach(function(p){ if(p.note.classList.contains('is-open')) place(p); }); },{passive:true});
  })();

  /* the bed only decodes and runs while the module is actually on screen */
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        inView=e.isIntersecting;
        if(!bed) return;
        if(inView){
          if(bed.preload!=='auto'){bed.preload='auto';bed.load();}
          if(!reduce.matches){var p=bed.play();if(p&&p.catch)p.catch(function(){});}
          kick();
        } else if(!bed.paused){ bed.pause(); }
      });
    },{rootMargin:'200px 0px'}).observe(track);
  } else if(bed){ bed.preload='auto'; bed.load(); }
  kick();
})();

/* -------------------------------------------------- section entrances */
var io=null;
if('IntersectionObserver' in window){
  io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting)return;
      e.target.classList.add('in');
      if(e.target.classList.contains('stg')){
        setTimeout(function(){e.target.classList.add('done');},1400);
      }
      io.unobserve(e.target);
    });
  },{threshold:0.16,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.stg,.rise,.rev,.guar,.close .buy').forEach(function(el){io.observe(el);});
}else{
  document.querySelectorAll('.stg,.rise,.rev,.close .buy').forEach(function(el){el.classList.add('in');});
}

/* --------------------------------------------- phone reveal on arrival
   On a phone the scroll-progress reveals are switched off in CSS, so these elements get the
   page's ordinary enter-the-viewport treatment instead. Desktop is untouched. */
(function mobileReveal(){
  if (!window.matchMedia('(max-width:900px)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var sel = '#buyModule,#buyClose,.scent__head,.sn li,.pin__copy .lede,.slam,' +
            '.guar__h,.guar__p,.steps__row,.loud__copy';
  var els = [].slice.call(document.querySelectorAll(sel));
  if (!els.length) return;
  els.forEach(function(e, i){
    e.classList.add('m-rise');
    e.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, {threshold:0.12, rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(e){ io.observe(e); });
})();

/* ------------------------------------------------------------ the menu
   Five links, a logo and a double-size shipping promise do not share a phone's header row,
   so below 900px the links live in a panel. Closes on choosing a link, on Escape, and on a
   tap outside — a menu that can only be closed by the button it was opened with is a trap. */
(function navMenu(){
  var nav = document.getElementById('nav'), btn = document.getElementById('navBurger'),
      menu = document.getElementById('navMenu');
  if (!nav || !btn || !menu) return;
  function setOpen(v){
    nav.classList.toggle('open', v);
    btn.setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    setOpen(!nav.classList.contains('open'));
  });
  menu.addEventListener('click', function(e){ if (e.target.closest('a')) setOpen(false); });
  document.addEventListener('click', function(e){
    if (nav.classList.contains('open') && !nav.contains(e.target)) setOpen(false);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && nav.classList.contains('open')){ setOpen(false); btn.focus(); }
  });
  window.matchMedia('(min-width:901px)').addEventListener('change', function(m){
    if (m.matches) setOpen(false);
  });
})();

/* ------------------------------------------------- environment layer */
var env=document.getElementById('env');
var envVideo=document.getElementById('envVideo');
function startEnv(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  /* phones keep the wash and the grain but never download the loop:
     it is decoration, and it is not worth a phone's bandwidth */
  if(matchMedia('(max-width: 900px)').matches||matchMedia('(pointer: coarse)').matches)return;
  if(startEnv.done)return;startEnv.done=true;
  envVideo.src=SMOKE_SRC;
  envVideo.load();
  var p=envVideo.play();
  if(p&&p.catch)p.catch(function(){});
  envVideo.addEventListener('playing',function(){env.classList.add('on');},{once:true});
}
if('requestIdleCallback' in window)requestIdleCallback(startEnv,{timeout:2500});
else setTimeout(startEnv,1600);

/* ------------------------------------------------------------- motes */
(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var host=document.getElementById('motes');
  var r=rng(776655);
  for(var i=0;i<12;i++){
    var m=document.createElement('div');
    m.className='mote';
    m.style.left=(r()*100).toFixed(2)+'%';
    m.style.bottom='-4vh';
    m.style.animationDelay=(-r()*22).toFixed(2)+'s';
    m.style.animationDuration=(17+r()*13).toFixed(1)+'s';
    m.style.opacity='0';
    host.appendChild(m);
  }
  host.classList.add('on');
})();

/* --------------------------------------- the one interactive moment */


/* ---------------------------------- reduced motion, live, both ways */
function pinToFinalStates(){
  document.querySelectorAll('.stg,.rise').forEach(function(el){el.classList.add('in','done');});
  document.querySelectorAll('#notes li').forEach(function(li){li.classList.add('lit');});
  if(window.__dropComplete)window.__dropComplete();
  bands.forEach(function(b){b.el.style.opacity='';b.el.style.setProperty('--k','1');});
  env.classList.remove('on');
  if(rafId!==null){cancelAnimationFrame(rafId);rafId=null;}
}
function unpinFinalStates(){
  bands.forEach(function(b){b.el.style.removeProperty('--k');});
}
matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change',function(e){
  /* The scrub is user-driven, so it survives this setting; only the ambient
     environment layer stops. applyHeroMode() re-reads the four real gates. */
  applyHeroMode();
  if(e.matches){ env.classList.remove('on'); }
  else{ startEnv(); }
});

/* ---------------------------------------- pause everything off-tab */
document.addEventListener('visibilitychange',function(){
  var hidden=document.hidden;
  document.body.classList.toggle('paused',hidden);
  if(envVideo.src){ if(hidden)envVideo.pause(); else {var q=envVideo.play(); if(q&&q.catch)q.catch(function(){});} }
});

/* ------------------------------------------------------------- boot */
applyHeroMode();

})();
